import { getStage } from "../../content/stages.js";
import type { GameState } from "../types/index.js";
import { accept, reject } from "./reject.js";

export function handleOpenStageSelect(state: GameState): GameState {
  const fromTitle = state.screen === "title";
  const fromResult = state.screen.startsWith("result.");
  const fromBringIn = state.screen === "bringIn";
  if (!fromTitle && !fromResult && !fromBringIn) {
    return reject(state, "ステージ選択はタイトルまたは結果画面からのみ可能");
  }
  return accept({ ...state, screen: "stageSelect", bringInStageId: null, overlay: "none" });
}

export function handleOpenBringIn(state: GameState, stageId: string): GameState {
  const fromStageSelect = state.screen === "stageSelect";
  const fromResult = state.screen.startsWith("result.");
  if (!fromStageSelect && !fromResult) {
    return reject(state, "持ち込み選択はステージ選択または結果画面からのみ可能");
  }
  if (!getStage(stageId).allowBringIn) {
    return reject(state, "このステージでは持ち込みは選べない");
  }
  return accept({ ...state, screen: "bringIn", bringInStageId: stageId, overlay: "none" });
}

export function handleBackToTitle(state: GameState): GameState {
  if (state.screen !== "stageSelect" && !state.screen.startsWith("result.")) {
    return reject(state, "タイトルへ戻れるのはステージ選択または結果画面からだけ");
  }
  return accept({ ...state, screen: "title", overlay: "none" });
}

export function canStartNew(screen: GameState["screen"]): boolean {
  return screen === "title" || screen === "stageSelect" || screen === "bringIn" || screen.startsWith("result.");
}
